export const STORAGE_SELECTED = 'civilizations.selectedOption';
export const STORAGE_QUICK = 'civilizations.quickSelect';
const EXPIRY_MS = 24 * 60 * 60 * 1000; // 24 hours

function isExpired(ts) {
  return Date.now() - ts > EXPIRY_MS;
}

export function loadSelectedOption() {
  try {
    const raw = localStorage.getItem(STORAGE_SELECTED);
    if (!raw) return '';

    // support legacy plain-string values
    let parsed;
    try {
      parsed = JSON.parse(raw);
    } catch {
      parsed = raw;
    }

    // new format: { value: string, ts: number }
    if (parsed && typeof parsed === 'object' && 'value' in parsed && 'ts' in parsed) {
      if (isExpired(parsed.ts)) {
        localStorage.removeItem(STORAGE_SELECTED);
        return '';
      }
      return parsed.value || '';
    }

    return typeof parsed === 'string' ? parsed : '';
  } catch {
    return '';
  }
}

export function saveSelectedOption(value) {
  try {
    if (value) {
      const payload = { value, ts: Date.now() };
      localStorage.setItem(STORAGE_SELECTED, JSON.stringify(payload));
    } else {
      localStorage.removeItem(STORAGE_SELECTED);
    }
  } catch {}
}

export function loadQuickSelect() {
  try {
    const raw = localStorage.getItem(STORAGE_QUICK);
    if (!raw) return [];

    let parsed;
    try {
      parsed = JSON.parse(raw);
    } catch {
      // corrupted or non-json => drop it
      return [];
    }

    // new format: { arr: [...], ts: number }
    if (parsed && typeof parsed === 'object' && 'arr' in parsed && 'ts' in parsed) {
      if (isExpired(parsed.ts)) {
        localStorage.removeItem(STORAGE_QUICK);
        return [];
      }
      return Array.isArray(parsed.arr) ? parsed.arr : [];
    }

    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function saveQuickSelect(arr) {
  try {
    if (arr && arr.length) {
      const payload = { arr, ts: Date.now() };
      localStorage.setItem(STORAGE_QUICK, JSON.stringify(payload));
    } else {
      localStorage.removeItem(STORAGE_QUICK);
    }
  } catch {}
}